import { useParams } from "react-router-dom";
import FormActions, {
  SchemaFormAction,
} from "../../components/forms/FormActionNew/FormAction";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import { useCrudAction } from "../../features/api/crud/hooks/useCrudAction";
import styles from "./PageConstatActionEdit.module.scss";
import { useMemo } from "react";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import dayjs from "dayjs";
import {
  useFetchActionQuery,
  useFetchConstatQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";

const PageConstatActionEdit: React.FC = () => {
  const { constatId, id } = useParams<{ id: string; constatId: string }>();

  const { data: action, isFetching: isFecthingAction } = useFetchActionQuery(
    id,
    {
      skip: !id,
    },
  );

  const { data: constat, isFetching: isFetchingConstat } = useFetchConstatQuery(
    Number(constatId),
    {
      skip: !constatId,
    },
  );

  const { data: dataPerformers, isFetching: isFetchingPorformers } =
    useFetchUsersForFieldQuery("");

  const { onSubmit, isLoading, isPostingAttachments } = useCrudAction(
    undefined,
    undefined,
    Number(constatId),
    true,
    action,
    "constat",
  );

  const defaultValues: SchemaFormAction = useMemo(() => {
    if (!action) {
      return {
        eventType: "CONSTAT",
        dateAsked: dayjs(),
        date: dayjs(),
        causeType: "CORRECTIF",
        title: "",
        description: "",
        effacity: "",
        pilote: "",
        performer: "",
        event: String(constatId),
      };
    }
    return {
      eventType: "CONSTAT",
      dateAsked: dayjs(action.dateAsked),
      date: dayjs(action.date),
      causeType: action.causeType,
      title: action.title || "",
      description: action.description || "",
      effacity: action.effacity || "",
      pilote: action.pilote || "",
      performer: String(action.performer?.id),
      event: String(constatId),
    };
  }, [action, constatId]);

  const isPageLoading =
    isFecthingAction ||
    isFetchingConstat ||
    isFetchingPorformers ||
    isPostingAttachments;

  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isPageLoading}>
      <Breadcrumbs
        pageName="constatAction"
        actionName={action?.title}
        actionId={Number(id)}
        eventName={constat?.name}
        eventId={Number(constatId)}
      />
      {!isPageLoading && (
        <FormActions
          isEditMode
          onSubmit={onSubmit}
          isLoading={isLoading || isPostingAttachments}
          defaultValues={defaultValues}
          performers={dataPerformers || []}
        />
      )}
    </PageLayout>
  );
};

export default PageConstatActionEdit;
